// Mock data for IMAGE-I management reporting

export const kpiCards = [
  {
    id: "finance",
    title: "Finance",
    metric: "$12.84M",
    delta: "+8.4%",
    trend: "up",
    description: "Revenue YTD",
    icon: "DollarSign",
    href: "/imagei/finance",
    recon: { status: "reconciled", pct: 99.4 },
    color: "#10b981",
  },
  {
    id: "sales",
    title: "Sales",
    metric: "4,219",
    delta: "+12.1%",
    trend: "up",
    description: "Closed deals (Q)",
    icon: "TrendingUp",
    href: "/imagei/sales",
    recon: { status: "reconciled", pct: 98.9 },
    color: "#10b981",
  },
  {
    id: "operations",
    title: "Operations",
    metric: "98.6%",
    delta: "+0.7%",
    trend: "up",
    description: "Service SLA",
    icon: "Activity",
    href: "/imagei/operations",
    recon: { status: "partial", pct: 96.2 },
    color: "#10b981",
  },
  {
    id: "hr",
    title: "Human Capital",
    metric: "2,184",
    delta: "-1.2%",
    trend: "down",
    description: "Headcount",
    icon: "Users",
    href: "/imagei/hr",
    recon: { status: "reconciled", pct: 100.0 },
    color: "#10b981",
  },
  {
    id: "supply",
    title: "Supply Chain",
    metric: "3.4 days",
    delta: "-0.6d",
    trend: "up",
    description: "Avg. lead time",
    icon: "Truck",
    href: "/imagei/supply",
    recon: { status: "partial", pct: 94.8 },
    color: "#10b981",
  },
  {
    id: "customer",
    title: "Customer",
    metric: "72 NPS",
    delta: "+4 pts",
    trend: "up",
    description: "Net Promoter Score",
    icon: "Heart",
    href: "/imagei/customer",
    recon: { status: "reconciled", pct: 99.1 },
    color: "#10b981",
  },
];

export const revenueTrend = [
  { month: "Jan", revenue: 820, forecast: 800 },
  { month: "Feb", revenue: 932, forecast: 900 },
  { month: "Mar", revenue: 901, forecast: 950 },
  { month: "Apr", revenue: 1034, forecast: 1000 },
  { month: "May", revenue: 1190, forecast: 1080 },
  { month: "Jun", revenue: 1230, forecast: 1150 },
  { month: "Jul", revenue: 1310, forecast: 1220 },
  { month: "Aug", revenue: 1402, forecast: 1300 },
  { month: "Sep", revenue: 1380, forecast: 1380 },
  { month: "Oct", revenue: 1520, forecast: 1450 },
  { month: "Nov", revenue: 1610, forecast: 1530 },
  { month: "Dec", revenue: 1748, forecast: 1620 },
];

export const segmentMix = [
  { name: "Enterprise", value: 48 },
  { name: "Mid-Market", value: 27 },
  { name: "SMB", value: 16 },
  { name: "Public Sector", value: 9 },
];

export const regionPerformance = [
  { region: "AMER", target: 100, actual: 112 },
  { region: "EMEA", target: 100, actual: 96 },
  { region: "APAC", target: 100, actual: 124 },
  { region: "LATAM", target: 100, actual: 88 },
];

export const operationalMetrics = [
  { week: "W1", uptime: 99.92, incidents: 3 },
  { week: "W2", uptime: 99.88, incidents: 5 },
  { week: "W3", uptime: 99.96, incidents: 2 },
  { week: "W4", uptime: 99.91, incidents: 4 },
  { week: "W5", uptime: 99.98, incidents: 1 },
  { week: "W6", uptime: 99.94, incidents: 3 },
];

export const headcountByDept = [
  { dept: "Engineering", count: 612 },
  { dept: "Sales", count: 418 },
  { dept: "Operations", count: 380 },
  { dept: "Customer Success", count: 274 },
  { dept: "Finance", count: 142 },
  { dept: "Marketing", count: 178 },
  { dept: "G&A", count: 180 },
];

export const recentReports = [
  { id: "r1", title: "Q4 Revenue Bridge", owner: "Finance", updated: "2h ago", status: "Live" },
  { id: "r2", title: "Pipeline Velocity by Segment", owner: "Sales Ops", updated: "5h ago", status: "Live" },
  { id: "r3", title: "Workforce Attrition Heatmap", owner: "People Analytics", updated: "1d ago", status: "Draft" },
  { id: "r4", title: "Service Desk SLA Breach Analysis", owner: "Operations", updated: "1d ago", status: "Live" },
  { id: "r5", title: "Supply Chain Risk Index", owner: "Procurement", updated: "2d ago", status: "Live" },
];

export const aiSkills = [
  { id: "general", label: "General Insights", description: "Cross-functional summaries & recommendations" },
  { id: "finance", label: "Finance Analyst", description: "Revenue, margin and variance commentary" },
  { id: "sales", label: "Sales Coach", description: "Pipeline health, win/loss patterns" },
  { id: "ops", label: "Ops Engineer", description: "SLAs, incidents, throughput diagnostics" },
  { id: "people", label: "People Analyst", description: "Headcount, attrition, engagement" },
];

// ============= Reconciliation engine =============


export const reconciliationSummary = {
  lastRun: "Today · 06:42",
  period: "Nov 2026",
  totalRecords: 18420,
  matched: 17684,
  variances: 612,
  missing: 124,
  matchRate: 96.0,
  netVariance: -284350,
  absVariance: 1248930,
};

export const reconciliationTrend = [
  { month: "Jun", matchRate: 92.1, variance: 412 },
  { month: "Jul", matchRate: 93.4, variance: 388 },
  { month: "Aug", matchRate: 94.2, variance: 360 },
  { month: "Sep", matchRate: 94.8, variance: 342 },
  { month: "Oct", matchRate: 95.6, variance: 298 },
  { month: "Nov", matchRate: 96.0, variance: 284 },
];

export const reconciliationAccounts = [
  { account: "1010 · Cash – Operating", books: 4820300, report: 4820300, variance: 0, status: "matched" },
  { account: "1200 · Accounts Receivable", books: 2184500, report: 2168720, variance: -15780, status: "variance" },
  { account: "1400 · Inventory", books: 3640000, report: 3712400, variance: 72400, status: "variance" },
  { account: "2010 · Accounts Payable", books: 1820400, report: 1820400, variance: 0, status: "matched" },
  { account: "2200 · Accrued Expenses", books: 542100, report: 530250, variance: -11850, status: "variance" },
  { account: "4000 · Revenue", books: 12840000, report: 12716200, variance: -123800, status: "variance" },
  { account: "5000 · COGS", books: 6120000, report: 6120000, variance: 0, status: "matched" },
  { account: "6100 · Marketing Spend", books: 482000, report: 0, variance: -482000, status: "missing" },
];

export const varianceByCategory = [
  { category: "Revenue", planned: 13000000, actual: 12716200, variance: -283800, drivers: "Enterprise renewal slip, FX headwind" },
  { category: "COGS", planned: 6000000, actual: 6120000, variance: -120000, drivers: "Logistics surcharge, supplier price hike" },
  { category: "OPEX", planned: 3200000, actual: 3084000, variance: 116000, drivers: "Hiring delay, deferred travel" },
  { category: "CAPEX", planned: 850000, actual: 612000, variance: 238000, drivers: "Project rollover into Q1" },
  { category: "Working Capital", planned: 1800000, actual: 2104000, variance: -304000, drivers: "AR aging > 60 days" },
];

// ============= Standard Costing — Variance Decomposition =============
// Bridge from Planned Margin → Actual Margin using standard costing principles.
// Sign convention: positive = favorable (F), negative = unfavorable (U).


export const standardCostingSummary = {
  plannedMargin: 4_800_000,
  actualMargin: 4_412_000,
  totalVariance: -388_000, // unfavorable
  currency: "USD",
  uom: "MT (metric tons)",
  period: "Nov 2026",
};

// Waterfall bridge: Plan → drivers → Actual
export const marginBridge = [
  { label: "Planned Margin", value: 4_800_000, type: "anchor" },
  { label: "Selling Price", value: +320_000, type: "delta" },     // price up
  { label: "Sales Volume", value: -150_000, type: "delta" },      // volume down
  { label: "Sales Mix", value: -60_000, type: "delta" },
  { label: "Input Material Cost", value: -240_000, type: "delta" }, // RM rate up
  { label: "Material Usage", value: -45_000, type: "delta" },
  { label: "Power & Fuel Rate", value: -118_000, type: "delta" },
  { label: "Power & Fuel Consumption", value: -72_000, type: "delta" },
  { label: "Other Variable Cost", value: -38_000, type: "delta" },
  { label: "Fixed Cost", value: +15_000, type: "delta" },
  { label: "Actual Margin", value: 4_412_000, type: "anchor" },
];

// Detailed standard-costing variance lines with business explanations
export const standardCostVariances = [
  {
    id: "spv",
    driver: "Selling Price Variance",
    kind: "price",
    formula: "(Actual Price − Standard Price) × Actual Qty",
    standard: 1_250,           // $/MT planned
    actual: 1_290,             // $/MT realized
    qty: 8_000,                // MT sold
    variance: +320_000,
    nature:"favorable",
    explanation:
      "Realised selling price increased by $40/MT vs standard, driven by an October list-price revision and stronger Enterprise mix in AMER. Net pricing power held despite EMEA discounting pressure.",
  },
  {
    id: "svv",
    driver: "Sales Volume Variance",
    kind: "volume",
    formula: "(Actual Qty − Budget Qty) × Standard Margin",
    standard: 8_500,           // budgeted MT
    actual: 8_000,             // actual MT
    qty: -500,
    variance: -150_000,
    nature:"unfavorable",
    explanation:
      "Volume fell 500 MT short of plan due to two enterprise renewals slipping from Nov to Dec and a softer APAC spot market.",
  },
  {
    id: "smv",
    driver: "Sales Mix Variance",
    kind: "mix",
    formula: "Σ (Actual Mix% − Std Mix%) × Std Margin × Total Qty",
    standard: 0,
    actual: 0,
    qty: 8_000,
    variance: -60_000,
    nature:"unfavorable",
    explanation:
      "Higher share of lower-margin SMB volume (+4pp) offset by reduced Enterprise share (−3pp). Mix shift drags blended margin by ~0.7pp.",
  },
  {
    id: "mpv",
    driver: "Input / Raw Material Cost",
    kind: "price",
    formula: "(Actual Rate − Std Rate) × Actual Qty Consumed",
    standard: 540,             // $/MT std raw input
    actual: 580,               // $/MT actual
    qty: 6_000,                // MT consumed
    variance: -240_000,
    nature:"unfavorable",
    explanation:
      "Key raw material price rose 7.4% over standard following supplier surcharge and freight pass-through. Hedging covered only 35% of exposure for the period.",
  },
  {
    id: "muv",
    driver: "Material Usage / Yield",
    kind: "usage",
    formula: "(Actual Qty − Std Qty for Output) × Std Rate",
    standard: 0.72,            // MT input per MT output (std)
    actual: 0.74,              // actual
    qty: 8_000,                // MT output
    variance: -45_000,
    nature:"unfavorable",
    explanation:
      "Yield loss of 2pp at Plant B linked to a calibration drift on Line 3 — flagged for maintenance window in week 49.",
  },
  {
    id: "pfr",
    driver: "Power & Fuel — Rate Variance",
    kind: "rate",
    formula: "(Actual Tariff − Std Tariff) × Actual Units Consumed",
    standard: 0.092,           // $/kWh std
    actual: 0.108,             // $/kWh actual
    qty: 7_375_000,            // kWh consumed
    variance: -118_000,
    nature:"unfavorable",
    explanation:
      "Grid tariff rose 17.4% vs standard following coal index escalation and a peak-hour demand surcharge in two regions.",
  },
  {
    id: "pfc",
    driver: "Power & Fuel — Consumption Variance",
    kind: "usage",
    formula: "(Actual Units − Std Units for Output) × Std Tariff",
    standard: 875,             // kWh per MT output (std)
    actual: 922,               // actual kWh per MT
    qty: 8_000,                // MT output
    variance: -72_000,
    nature:"unfavorable",
    explanation:
      "Specific energy consumption rose 5.4% above standard. Root cause: increased reheat cycles on Furnace 2 and ambient-temperature inefficiencies in cooling tower.",
  },
  {
    id: "ovc",
    driver: "Other Variable Cost",
    kind: "spend",
    formula: "Actual Variable Spend − (Std Rate × Actual Output)",
    standard: 95_000,
    actual: 133_000,
    qty: 8_000,
    variance: -38_000,
    nature:"unfavorable",
    explanation:
      "Consumables, packaging and outbound logistics ran above standard due to expedited shipments and one-off resin price spike.",
  },
  {
    id: "fxv",
    driver: "Fixed Cost (Spending)",
    kind: "spend",
    formula: "Actual Fixed Cost − Budgeted Fixed Cost",
    standard: 1_400_000,
    actual: 1_385_000,
    qty: 1,
    variance: +15_000,
    nature:"favorable",
    explanation:
      "Marginal favourable spend on plant overheads from deferred maintenance and lower insurance premium renewal. Headcount additions remain on plan.",
  },
];

export const aiInsights = [
  {
    id: "i1",
    severity:"high",
    title: "Revenue under plan by 2.2%",
    body: "Two enterprise renewals ($180K combined) slipped from Nov to Dec. Forecast cone suggests 78% likelihood of recovery in Q1. Recommend escalating CSM contact this week.",
  },
  {
    id: "i2",
    severity:"medium",
    title: "Inventory variance flagged at SKU level",
    body: "Warehouse 3 reports +$72K vs books — likely cycle-count timing. Trigger reconciliation against last GR/IR posting.",
  },
  {
    id: "i3",
    severity:"high",
    title: "Marketing spend missing from report feed",
    body: "$482K of GL postings have no matching report record. Source pipeline 'mkt-spend-api' last succeeded 36h ago. Re-run extraction.",
  },
  {
    id: "i4",
    severity:"low",
    title: "OPEX favorable variance",
    body: "Hiring lag created $116K favorable variance — sustainable through Q1 if backfill plan is delayed by 30 days.",
  },
];

// ============= Historical performance (8-quarter trailing) =============

export const historicalPerformance = [
  { period: "Q1 2025", revenue: 11_240_000, margin: 3_980_000, marginPct: 35.4, matchRate: 92.1, netVariance: -512_000 },
  { period: "Q2 2025", revenue: 11_580_000, margin: 4_120_000, marginPct: 35.6, matchRate: 93.0, netVariance: -468_000 },
  { period: "Q3 2025", revenue: 11_910_000, margin: 4_210_000, marginPct: 35.4, matchRate: 93.8, netVariance: -402_000 },
  { period: "Q4 2025", revenue: 12_360_000, margin: 4_360_000, marginPct: 35.3, matchRate: 94.5, netVariance: -358_000 },
  { period: "Q1 2026", revenue: 12_120_000, margin: 4_240_000, marginPct: 35.0, matchRate: 95.0, netVariance: -332_000 },
  { period: "Q2 2026", revenue: 12_480_000, margin: 4_380_000, marginPct: 35.1, matchRate: 95.4, netVariance: -310_000 },
  { period: "Q3 2026", revenue: 12_640_000, margin: 4_420_000, marginPct: 35.0, matchRate: 95.8, netVariance: -298_000 },
  { period: "Q4 2026", revenue: 12_840_000, margin: 4_412_000, marginPct: 34.4, matchRate: 96.0, netVariance: -284_350 },
];

// ============= Peer / benchmark companies =============

export const peerBenchmarks = [
  {
    id: "self",
    name: "Our Company",
    ticker: "—",
    segment: "Industrial Materials",
    revenue: 12_840_000,
    growthYoY: 8.4,
    grossMargin: 34.4,
    ebitdaMargin: 18.2,
    energyIntensity: 922,
    rmCostIndex: 107,
    rating: "peer",
  },
  {
    id: "peer-a",
    name: "Northwind Materials",
    ticker: "NWM",
    segment: "Industrial Materials",
    revenue: 18_420_000,
    growthYoY: 11.2,
    grossMargin: 37.8,
    ebitdaMargin: 21.4,
    energyIntensity: 868,
    rmCostIndex: 102,
    rating: "leader",
  },
  {
    id: "peer-b",
    name: "Helix Industrial",
    ticker: "HLXI",
    segment: "Industrial Materials",
    revenue: 14_120_000,
    growthYoY: 6.1,
    grossMargin: 33.9,
    ebitdaMargin: 17.6,
    energyIntensity: 940,
    rmCostIndex: 110,
    rating: "peer",
  },
  {
    id: "peer-c",
    name: "Cobalt Process Co.",
    ticker: "CBLT",
    segment: "Specialty Chemicals",
    revenue: 9_780_000,
    growthYoY: 3.4,
    grossMargin: 31.2,
    ebitdaMargin: 14.1,
    energyIntensity: 988,
    rmCostIndex: 113,
    rating: "laggard",
  },
  {
    id: "peer-d",
    name: "Atlas Forge",
    ticker: "ATLF",
    segment: "Industrial Materials",
    revenue: 22_510_000,
    growthYoY: 9.6,
    grossMargin: 38.4,
    ebitdaMargin: 22.9,
    energyIntensity: 845,
    rmCostIndex: 99,
    rating: "leader",
  },
];

// ============= Industry / market news =============

export const industryNews = [
  {
    id: "n1",
    source: "Reuters",
    publishedAt: "2h ago",
    headline: "Coal index spikes 6% on tightening winter supply",
    summary:
      "Spot coal prices rose to a 9-month high, reinforcing the unfavourable Power & Fuel rate variance and pressuring Q1 cost guidance for energy-intensive producers.",
    category: "commodity",
    sentiment: "negative",
    impact: "high",
    url: "#",
  },
  {
    id: "n2",
    source: "Bloomberg",
    publishedAt: "5h ago",
    headline: "Northwind Materials beats Q4 estimates, raises FY guide",
    summary:
      "Peer NWM posted 37.8% gross margin (+220 bps YoY), citing energy efficiency program and 60% raw-material hedge coverage. Implies ~340 bps gross-margin gap vs us.",
    category: "peer",
    sentiment: "positive",
    impact: "high",
    url: "#",
  },
  {
    id: "n3",
    source: "FT",
    publishedAt: "1d ago",
    headline: "EU CBAM phase-in to add ~1.4% landed cost on imported feedstock",
    summary:
      "Carbon Border Adjustment Mechanism enters expanded phase Jan 2027. Procurement should re-tender EMEA suppliers and quantify impact on Input Material Cost variance.",
    category: "regulation",
    sentiment: "negative",
    impact: "medium",
    url: "#",
  },
  {
    id: "n4",
    source: "Wall Street Journal",
    publishedAt: "1d ago",
    headline: "Atlas Forge announces $180M efficiency capex over 24 months",
    summary:
      "ATLF targets 8% reduction in energy intensity by 2028 — would extend its leadership on kWh/MT and widen the unit-cost gap unless we accelerate Furnace 2 retrofit.",
    category: "peer",
    sentiment: "negative",
    impact: "medium",
    url: "#",
  },
  {
    id: "n5",
    source: "S&P Global",
    publishedAt: "2d ago",
    headline: "Industrial Materials sector PMI rebounds to 52.4",
    summary:
      "Demand signals firm after two soft quarters. Supports a recovery scenario for the Sales Volume variance and APAC spot weakness flagged this period.",
    category: "macro",
    sentiment: "positive",
    impact: "medium",
    url: "#",
  },
  {
    id: "n6",
    source: "Internal · Investor Relations",
    publishedAt: "3d ago",
    headline: "Q4 earnings call scheduled — variance commentary required",
    summary:
      "Investor day prep: align variance bridge narrative (Selling Price F, Input Cost U, Power & Fuel U) with peer commentary and management actions.",
    category: "company",
    sentiment: "neutral",
    impact: "low",
    url: "#",
  },
];